import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React from 'react';

function useForceUpdate() {
  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      updateState = _React$useState2[1];

  var forceUpdate = React.useCallback(function () {
    updateState({});
  }, []);
  return forceUpdate;
}

export default useForceUpdate;